module.exports = __webpack_public_path__ + "static/media/mapping-consumer-data-video-001.ab2b556c.mp4";